import { createSlice } from '@reduxjs/toolkit';

import { ProductUnitDto } from '../../../../types/products';
import { SLICE_BASE_NAME } from '../../auth/constant';

interface UnitList extends ProductUnitDto {
  id: string;
}

interface Unit {
  unitList: UnitList[];
}

const initialState: Unit = {
  unitList: [],
};

const unitSlice = createSlice({
  name: `${SLICE_BASE_NAME}/products/unit`,
  initialState,
  reducers: {
    addUnit(_state, _action) {
      // state.unitList = action.payload;
    },
  },
});

export const { addUnit } = unitSlice.actions;
export default unitSlice.reducer;
